<template>
  <model-provider :service="service" :model-id="id">
    <template #default="{model}">
      <b-card>
        <div class="flex flex-col gap-4">
          <contact-list-form ref="form" @reset="$router.back()" @submit="storeContactList" :model="model">
            <template #reset-button-text>
              Voltar
            </template>
          </contact-list-form>
          <template v-if="id">
            <div class="w-full border-b border-t-0 border-grey mt-8 border-solid" style="height: 0px;"></div>
            <div>
              <contact-form
                ref="input-contact-form"
                @submit="addContact"
                @search="searchContact"
                :model="contactInput"
                inline
                inline-input>
                <template #search-button>
                  <b-button v-b-modal.search-contact variant="outline-primary" @click="search">
                    <feather-icon
                      icon="SearchIcon"
                      class="mr-50"
                    />
                    <span class="align-middle">Buscar</span>
                  </b-button>
                </template>
              </contact-form>
            </div>
            <Grid :key="gridKey" ref="grid" expandable :force-filters="{from_list_id:id}" :service="contactService">
              <template v-if="showInlineEditing" :slot="`row-${editingRow}`">
                <td colspan="5" class="bg-grey-light">
                  <contact-form ref="inline-contact-form" @submit="storeInline" @reset="closeInline" compact :model="inlineEdit" inline>
                    <template #reset-button-text>
                      Cancelar
                    </template>
                  </contact-form>
                </td>
              </template>
              <template #actions="actions">
                <!--
                <feather-icon
                  v-permission="`contact_lists.edit`"
                  icon="EditIcon"
                  class="cursor-pointer h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                  v-if="!hide_edit"
                  @click="showInline(actions.indextr, actions.row)"/>
                -->
                <feather-icon
                  v-permission="`contact_lists.delete`"
                  icon="Trash2Icon"
                  class="cursor-pointer h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                  v-if="!hide_delete"
                  @click="removeContact(actions.row)"
                />
              </template>
            </Grid>
          </template>
        </div>
      </b-card>
      <b-modal ok-only @ok="addSelectedContacts" size="xl" id="search-contact">
        <template #default>
          <Grid
            multiple-select
            @changedSelection="updateSelectedContacts"
            ref="grid" expandable
            :service="contactService"
          />
        </template>
        <template #modal-title>
          Buscar Contato
        </template>
        <template #modal-ok>
          Adicionar
        </template>
        <template #modal-cancel>
          Voltar
        </template>
      </b-modal>
    </template>
  </model-provider>
</template>

<script>
import ContactListService from '@/services/api/ContactListService'
import ContactService from '@/services/api/ContactService'
import ModelProvider from '@/components/ModelProvider.vue'

import {
  BCard,
  BButton,
  BTable,
  BModal,
} from 'bootstrap-vue'
  import ContactListForm from './ContactListForm.vue'
import ContactForm from '../ContactForm.vue'

export default {

  props: {
    id: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    service: null,
    model: {
      name: '',
      description: ''
    },
    gridKey: 0,
    // Contact inputting
    contactService: null,
    contactInput: {
      name: '',
      email: '',
      phone: ''
    },
    showSearchContact: false,
    selectedContacts: [],
    // Inline contact editing
    showInlineEditing: false,
    editingRow: 0,
    inlineEdit: {
      id: null,
      name: '',
      email: '',
      phone: ''
    }
  }),

  components: {
    ModelProvider,
    BCard,
    BButton,
    ContactListForm,
    ContactForm,
    BTable,
    BModal,
  },
  mounted(){

  },
  beforeMount() {
    this.service = ContactListService.build(this.$vs)
    this.contactService = ContactService.build(this.$vs)
  },

  methods: {
    removeContact(contact) {
      const contactId = this._.get(contact, 'id')

      if (contactId) {
        this.$vs.loading()
        this.service.removeContact(this.id, contactId).then(
          response => {
            this.$refs.grid.fetchGridData()
            this.notifySuccess(this.$vs, 'Contato removido.')
          }
        ).finally(
          () => this.$vs.loading.close()
        )
      }
    },
    updateSelectedContacts(contacts) {
      this.selectedContacts = contacts
    },
    addSelectedContacts() {
      this.addManyContacts(this.selectedContacts)
    },
    makeAddContactRequest(model) {
      return this.service.addContact(this.id, model)
    },
    addContact(model) {
      this.$vs.loading()
      this.$refs['input-contact-form'].clearValidationErrors()
      const request = this.makeAddContactRequest(model)
      request.then(
        (success) => {
          this.notifySuccess(this.$vs, "Contato adicionado à lista com sucesso.")
          this.$refs.grid.fetchGridData()
          this.$refs['input-contact-form'].clear()
        },
        (error) => {
          this.notifyWarning(this.$vs, "Verifique os campos obrigatórios.")
          this.$refs['input-contact-form'].showValidationErrors(error)
        }
      )
      request.finally(
        () => this.$vs.loading.close()
      )

      return request
    },
    addManyContacts(contactIdList) {
      this.$vs.loading()
      if (contactIdList && this._.isArray(contactIdList)) {
        const requests = []
        contactIdList.forEach((contactId) => {
          const request = this.makeAddContactRequest({id: contactId})
          request.catch(() => {
            this.notifyError(this.$vs, "Não foi possível adicionar um contato")
          })
          requests.push(request)
        })

        Promise.all(requests).then(
          responses => {
            this.selectedContacts = []
            this.$bvModal.hide('search-contact')
            this.showSearchContact = false
            this.$nextTick(
              () => {
                this.gridKey++
                //this.$refs.grid.fetchGridData()
              }
            )
            this.notifySuccess(this.$vs, "Contatos adicionados com sucesso!")
          }
        ).finally(
          () => this.$vs.loading.close()
        )
      }
    },
    searchContact() {
      this.showSearchContact = true
    },
    storeContactList(data) {
      this.clearErrors(this.$validator)
      this.$vs.loading()
      this.service.createOrUpdate({
        id: this.id,
        ...data
      }).then(
        response => {
          this.notifySuccess(this.$vs, "Operação realizada com sucesso!")
          this.model = response
          this.$router.push(`/contact-lists/${response.id}/edit`)
        },
        error => {
          this.$refs.form.showValidationErrors(error)
          this.notifyError(this.$vs, "Não foi possível realizar esta operação.")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    storeInline(model) {
      const editingRow = this.editingRow

      this.$vs.loading()
      this.contactService.createOrUpdate({id: this.inlineEdit.id, ...model}).then(
        response => {
          this.$refs.grid.fetchGridData()
          this.notifySuccess(this.$vs, "Contato atualizado com sucesso!")
          this.closeInline()
          this.clearErrors(this.$validator)
        },
        error => {
          this.$refs['inline-contact-form'].showValidationErrors(error)
          this.notifyError(this.$vs, "Não foi possível atualizar este contato, tente novamente")
        }
      ).then(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    showInline(indextr, model) {
      this.inlineEdit = model
      this.showInlineEditing = true
      this.editingRow = indextr
    },
    closeInline() {
      this.showInlineEditing = false
      this.editingRow = 0
    }
  }
}
</script>

<style>

</style>
